import React, { useEffect, useState } from "react";
import {
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Card,
  CardContent,
  Typography,
  Button,
} from "@mui/material";
import { Edit } from "@mui/icons-material";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import api from "../api";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import MDInput from "components/MDInput";
import MDBox from "components/MDBox";

const Retornos = () => {
  const [firebaseUser, setFirebaseUser] = useState(null);
  const [dbUser, setDbUser] = useState("");
  const [retornos, setRetornos] = useState([]);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [selectedRetorno, setSelectedRetorno] = useState(null);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setFirebaseUser(user || null);
      setDbUser(user ? user.displayName || user.uid : "");
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (!dbUser) return;
    const nowEpoch = Math.floor(Date.now() / 1000);
    const THIRTY_DAYS = 30 * 24 * 60 * 60;
    api.retornosFecha(dbUser, nowEpoch - (12 * THIRTY_DAYS), nowEpoch).then(setRetornos);
  }, [dbUser]);

  const handleEdit = (retorno) => {
    setSelectedRetorno({ ...retorno });
    setOpenEditModal(true);
  };

  const handleEditChange = (e) => {
    setSelectedRetorno({
      ...selectedRetorno,
      [e.target.name]: e.target.value,
    });
  };

  const handleSaveEdit = async () => {
    if (!selectedRetorno) return;
    await api.updateRetorno(selectedRetorno);
    setRetornos(retornos.map((r) => (r.id === selectedRetorno.id ? selectedRetorno : r)));
    setOpenEditModal(false);
  };

  const columns = [
    { Header: "Fecha", accessor: "fecha", Cell: ({ value }) => (<b>{new Date(value * 1000).toISOString().slice(0, 10)}</b>) },
    { Header: "Monto USD", accessor: "monto_usd" },
    {Header: "PIN", accessor: "pin"},
    {
      Header: "Acciones",
      accessor: "acciones",
      Cell: ({ row }) => (
        <IconButton color="primary" onClick={() => handleEdit(row.original)}>
          <Edit />
        </IconButton>
      ),
    },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Card>
        <CardContent>
          <Typography variant="h4" gutterBottom color="primary">
            Retornos
          </Typography>
          <DataTable table={{ columns, rows: retornos }} isSorted entriesPerPage showTotalEntries canSearch />
        </CardContent>
      </Card>

      {/* MODAL DE EDICIÓN */}
      <Dialog open={openEditModal} onClose={() => setOpenEditModal(false)}
         sx={{ "& .MuiPaper-root": { bgcolor: "background.default", color: "white" } }}>
        <DialogTitle>Editar Retorno</DialogTitle>
        <DialogContent p={2}>
          {selectedRetorno && (
            <MDBox p = {2}>
              <MDInput  label="Monto USD" name="monto_usd" type="number" value={selectedRetorno.monto_usd} onChange={handleEditChange} fullWidth />
            </MDBox>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenEditModal(false)} color="secondary">
            Cancelar
          </Button>
          <Button onClick={handleSaveEdit} color="primary">
            Guardar
          </Button>
        </DialogActions>
      </Dialog>

      <Footer />
    </DashboardLayout>
  );
};

export default Retornos;
